// GENERAL
import React from "react";

// TYPES
import { BaseHeaderCellTypes } from "../../types";
import { ColumnInstance } from "react-table";

// COMPONENTS
import TableHeaderContent from "@agilant/toga-blox/dist/components/TableHeaderContent/TableHeaderContent";
import HeaderFilterIcon from "@agilant/toga-blox/dist/components/HeaderFilterIcon/HeaderFilterIcon";
import SupplyPortal from "../../../../SupplyPortal";
import SortArrows from "../../components/tableActions/SortArrows";
import InputAndCheck from "../tableActions/InputAndCheck";

const PortalOverlay: React.FC = () => (
	<SupplyPortal containerId="portal-root">
		<div className="w-full h-full absolute top-0"></div>
	</SupplyPortal>
);

const BaseHeaderCell = <T extends object>({
	column,
	isLeftColumnStickyHeader,
	headerGroupIndex,
	columnIndex,
	editingHeader,
	updatedColumn,
	containerRef,
	isLastOfLeftStickyColumns,
	setEditingHeader,
	searchResultsPillColor,
	slug,
	mappingField,
	inputRef,
	columnIsRightActionBar,
	isNestedChildTable,
	isTableSearchAndSortEnabled,
	setSortColumn,
	handleSortChange,
	parentIndex,
	setHeaderValue,
	magnifyingIconRef,
	searchText,
	activeCols,
	setSearchColumn,
	filterIcon,
	filterWeight,
}: BaseHeaderCellTypes<T>) => {
	return (
		<>
			<th
				className={`text-navy-500 font-omnes-medium font-medium text-sm text-nowrap sticky top-0 z-10 bg-supply-blue-50 min-w-full  `}
				{...column.getHeaderProps()}
				style={{
					...(isLeftColumnStickyHeader
						? {
								position: "sticky",
								left: (column as any).style?.left,
								zIndex: 50,
						  }
						: {}),
				}}
				key={`header-${headerGroupIndex}-column-${columnIndex}`}
			>
				<div
					className={`px-5 bg-supply-blue-50 items-center min-h-8 flex break-words whitespace-normal relative `}
				>
					{editingHeader === columnIndex ? (
						<>
							<TableHeaderContent column={updatedColumn} />
							<div
								className="absolute w-full top-[-5px] bottom-4 "
								ref={containerRef}
							>
								<div className="absolute top-10 z-20 bg-white w-max">
									<InputAndCheck
										setEditingHeader={setEditingHeader}
										column={updatedColumn}
										closeOutSearch={() =>
											setEditingHeader(null)
										}
										setResetSearch={() => []}
										pillColor={searchResultsPillColor}
										slug={slug}
										columnSlug={mappingField}
									/>
									{(() => {
										inputRef.current?.focus();
										return null;
									})()}
								</div>
							</div>
							<PortalOverlay />
						</>
					) : (
						<TableHeaderContent column={updatedColumn} />
					)}
					{!columnIsRightActionBar &&
						!isNestedChildTable &&
						isTableSearchAndSortEnabled && (
							<div className="ml-1">
								<SortArrows
									slug={mappingField || ""}
									parentIndex={parentIndex}
									isNested={isNestedChildTable}
									column={{
										...updatedColumn,
										accessor: String(
											updatedColumn.accessor
										),
									}}
									setSortColumn={setSortColumn}
									onSortChange={handleSortChange}
								/>
							</div>
						)}

					{filterIcon &&
						(!columnIsRightActionBar || isNestedChildTable) &&
						isTableSearchAndSortEnabled && (
							<div className="">
								<HeaderFilterIcon
									ref={magnifyingIconRef}
									editingHeader={editingHeader}
									columnIndex={columnIndex}
									column={
										updatedColumn as ColumnInstance<any>
									}
									setEditingHeader={setEditingHeader}
									setHeaderValue={setHeaderValue}
									searchText={searchText}
									isActive={activeCols.includes(columnIndex)}
									isSearchOpen={editingHeader !== null}
									additionalIconClasses={
										activeCols.includes(columnIndex)
											? "text-white"
											: "text-navy-400"
									}
									iconActiveBackgroundColor="bg-supply-blue-400"
									setActiveColumn={setSearchColumn}
									icon={{
										icon: filterIcon,
										weight: filterWeight as
											| "solid"
											| "regular"
											| "light",
									}}
									itemHoverColor="hover:bg-white"
									iconActiveColor="text-white"
								/>
							</div>
						)}
				</div>
				{isLastOfLeftStickyColumns && (
					<div className="w-[1px] h-full bg-gray-300 absolute right-0 top-0"></div>
				)}
			</th>
		</>
	);
};

export default BaseHeaderCell;
